import { ObjectCreator } from "../../../../web-graphics";

export class IirFilter {
  constructor(B, A, TYPE) {
    this.B = ObjectCreator.deepCopy(B);
    this.A = ObjectCreator.deepCopy(A);
    this.TYPE = TYPE;

    this.dStk = this.B.length - 1;
    this.xStk = new Float64Array(this.dStk);
    this.yStk = new Float64Array(this.dStk);

    this.isFirst = true;
    this.pStk = 0;
  }

  settings(/*x*/) {}

  reset() {
    this.isFirst = true;
    this.pStk = 0;
  }

  exe(x) {
    /*
    if (this.isFirst) {
      this.isFirst = false;
      this.settings(x);
    }
    */
    let y = x * this.B[0];
    for (let i = this.dStk; i > 0; i--) {
      y = y + this.xStk[this.pStk] * this.B[i] - this.yStk[this.pStk] * this.A[i];
      this.pStk++;
      if (this.pStk == this.dStk) {
        this.pStk = 0;
      }
    }
    this.xStk[this.pStk] = x;
    this.yStk[this.pStk] = y;
    this.pStk++;
    if (this.pStk == this.dStk) {
      this.pStk = 0;
    }
    return y;
  }

  copy() {
    return new IirFilter(this.B, this.A, this.TYPE);
  }
}

export class HighIirFilter extends IirFilter {
  constructor(B, A) {
    super(B, A, "HIGH");
  }

  settings(x) {
    for (let i = 0; i < this.dStk; i++) {
      this.xStk[i] = x; // x
      this.yStk[i] = 0; // y
    }
    this.isFirst = false;
  }

  copy() {
    return new HighIirFilter(this.B, this.A);
  }
}

export class LowIirFilter extends IirFilter {
  constructor(B, A) {
    super(B, A, "LOW");
  }

  settings(x) {
    for (let i = 0; i < this.dStk; i++) {
      this.xStk[i] = x; // x
      this.yStk[i] = x; // y
    }
    this.isFirst = false;
  }

  copy() {
    return new LowIirFilter(this.B, this.A);
  }
}

export class Filter50Batterword1000Hz extends LowIirFilter {
  constructor() {
    super(
      new Float64Array([0.91496914411305241, -3.4876315109841611, 5.1534311171019684, -3.4876315109841611, 0.91496914411305241]),
      new Float64Array([1.0, -3.6427871266953291, 5.1461877540722796, -3.3324758952732214, 0.83718165125602195])
    );
  }

  copy() {
    return new Filter50Batterword1000Hz();
  }
}

export class Filter35Batterword1000Hz extends LowIirFilter {
  constructor() {
    super(
      new Float64Array([0.010432413371093407, 0.020864826742186815, 0.010432413371093407]),
      new Float64Array([1.0, -1.6909963768874428, 0.73272603037181638])
    );
  }

  copy() {
    return new Filter35Batterword1000Hz();
  }
}

export class Filter01Batterword1000Hz extends HighIirFilter {
  constructor() {
    super(
      new Float64Array([0.9995558103876086564198999, -1.9991116207752173128397999, 0.9995558103876086564198999]),
      new Float64Array([1.0, -1.9991114234707958452474941, 0.9991118180796387804321057])
    );
  }

  copy() {
    return new Filter01Batterword1000Hz();
  }
}

export class Filter50Batterword250Hz extends LowIirFilter {
  constructor() {
    super(
      new Float64Array([0.69977432, -0.89302464, 1.68445942, -0.89302464, 0.69977432]),
      new Float64Array([1, -1.05515698, 1.59219581, -0.730892229, 0.49181224])
    );
  }

  copy() {
    return new Filter50Batterword250Hz();
  }
}

export class Filter35Batterword250Hz extends LowIirFilter {
  constructor() {
    super(new Float64Array([0.11735104, 0.23470207, 0.11735104]), new Float64Array([1, -0.82523238, 0.29463653]));
  }

  copy() {
    return new Filter35Batterword250Hz();
  }
}

export class Filter01Batterword250Hz extends HighIirFilter {
  constructor() {
    super(new Float64Array([0.99911182, -1.99822364, 0.99911182]), new Float64Array([1, -1.99822285, 0.99822443]));
  }

  copy() {
    return new Filter01Batterword250Hz();
  }
}
